import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col} from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
import { validateTransactionApi } from '../../../utils/AdminDashApi/ValidateTransactionApi'
const ValidateTransactionCompmb = () => {
  const [transactionid,settransactionid] = useState("")
  const [labeltransactionid,setlabeltransactionid] = useState("")
  const [bordertransactionid,setbordertransactionid] = useState("")

  const continueButton=()=>{

  }

  return (
    <>
      <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
          <div className="mobilecontainer">
            <div className="adminmbheading">
              <h3>Validate Transaction</h3>
            </div>
            <div className="admbwrap">
              <Row>
              <MobileInputSubComp col="12" direct="center" name="Transaction ID">
                        <input style={bordertransactionid ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={transactionid} onChange={(e) => settransactionid(e.target.value)} />
                        <label>{labeltransactionid}</label>
                </MobileInputSubComp>
                <Col xs={12} className='text-center'>
                  <div className="purplebutton">
                    <button className='px-4 py-2' onClick={continueButton}>
                      Continue
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="admbwrap">
            <Row  className="validatetransactionmain">
                        <Col lg={10} className="m-auto" >
                            <h3 className="text-center">Student's Information</h3>

                            <table>
                                {
                                    validateTransactionApi.data.map((item,key)=>{
                                        return(
                                            <tr>
                                   
                                                <td>
                                                    <span>{item.name}</span> <span>:</span>
                                                </td>
                                                <td>
                                                    {item.value}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                               
                               
                            </table>
                        </Col>
                    </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ValidateTransactionCompmb